import { useFlags } from 'launchdarkly-react-client-sdk';
import { Helmet } from 'react-helmet';
import { Navigate, Route, Routes } from 'react-router-dom';

import { Create } from './settings/organizations/CreateOrganization';
import { EditOrganization } from './settings/organizations/EditOrganization';
import { OrganizationDetails } from './settings/organizations/Organization';
import { Organizations } from './settings/organizations/Organizations';
import { EditPaymentSchedule } from './settings/organizations/Payments/EditPaymentSchedule';

export function Settings() {
  const { enablePayouts = false } = useFlags();

  return (
    <>
      <Helmet>
        <title>Settings</title>
      </Helmet>
      <Routes>
        <Route path="organizations" element={<Organizations />} />
        <Route path="organizations/new" element={<Create />} />
        <Route path="organizations/:alias/*" element={<OrganizationDetails />} />
        <Route path="organizations/:alias/edit" element={<EditOrganization />} />
        {enablePayouts && (
          <Route path="organizations/:alias/payments/:programType/edit" element={<EditPaymentSchedule />} />
        )}
        <Route path="*" element={<Navigate to="/settings/organizations" />} />
      </Routes>
    </>
  );
}
